import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../../restServiceConnection';

const ENDPOINT = '/carrion-photos';

export class CarrionPhotosService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES DELETE PHOTO
     * @EN ELIMINAR FOTO
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteCarrionPhoto = async (id?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADIR UNA O VARIAS FOTOS A LA CARROÑA
     * @EN ADD ONE OR MORE PHOTOS TO THE CARRION
     * 
     * @param formData
     */
    // -------------------------------------------------------------------------------------------------------------
    addCarrionPhoto = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-photos',
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER UNA FOTO POR SU ID
     * @EN GET A PHOTO BY ITS ID
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getCarrionPhotoById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES RENDERIZAR UNA FOTO
     * @EN RENDER A PHOTO
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    renderPhoto = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/render',
            data: {
                id: id
            },
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER TODAS LAS FOTOS DE UNA CARROÑA
     * @EN GET ALL PHOTOS OF AN CARRION
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getAllPhotosFromCarrion = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-all-photos',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}